<script lang="ts" setup>
// This file serves as the Colections Router View
// => see https://uvr.esm.is/guide/file-based-routing.html#nested-routes
import AsyncLoader from "@/components/AsyncLoader.vue";
import { useCollectionsQueries } from "@/composables/useCollectionsQueries";

const route = useRoute();
const routeParams = route.params as {
  id: string;
};
const id = computed(() => routeParams.id);

const { useGetCollectionQuery } = useCollectionsQueries();
const { data: collection, ...asyncStatus } = useGetCollectionQuery({
  id: id.value,
});
</script>

<template>
  <TheLayout :with-main-margin="false">
    <MainFobizzNavbar />
    <AsyncLoader :async-status="asyncStatus">
      <template #resolved>
        <router-view :collection="collection" />
      </template>
    </AsyncLoader>
  </TheLayout>
</template>
